import { render, staticRenderFns } from "./TaskDistributions.vue?vue&type=template&id=8b4fedc0&scoped=true"
import script from "./TaskDistributions.vue?vue&type=script&lang=js"
export * from "./TaskDistributions.vue?vue&type=script&lang=js"
import style0 from "./TaskDistributions.vue?vue&type=style&index=0&id=8b4fedc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4fedc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b4fedc0')) {
      api.createRecord('8b4fedc0', component.options)
    } else {
      api.reload('8b4fedc0', component.options)
    }
    module.hot.accept("./TaskDistributions.vue?vue&type=template&id=8b4fedc0&scoped=true", function () {
      api.rerender('8b4fedc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskElement/TaskDistributions.vue"
export default component.exports